{
  "name": "@m3s/crosschain",
  "version": "2.2.10",
  "type": "module",
  "description": "A simplified cross-chain transfer library built on top of LI.FI, enabling token transfers between different blockchain networks with minimal configuration",
  "license": "MIT",
  "keywords": [
    "cross-chain",
    "bridge",
    "swap",
    "token",
    "ethereum",
    "blockchain",
    "lifi",
    "defi"
  ],
  "repository": {
    "type": "git",
    "url": "git@bitbucket.org:ctb-marisca/ms3-package.git",
    "directory": "packages/crosschain"
  },
  "main": "./dist/index.cjs.js",
  "module": "./dist/index.esm.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.esm.js",
      "require": "./dist/index.cjs.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "build": "tsc -b",
    "prepublishOnly": "npm run build",
    "test": "vitest run --sequence.sequential"
  },
  "dependencies": {
    "@lifi/sdk": "^3.6.6",
    "@m3s/wallet": "^2.4.9",
    "ethers": "^6.13.5",
    "eventemitter3": "^5.0.1",
    "joi": "^17.13.3",
    "viem": "^2.23.2"
  },
  "devDependencies": {
    "@m3s/shared": "*"
  },
  "publishConfig": {
    "access": "public",
    "tag": "latest"
  },
  "files": [
    "dist",
    "README.md"
  ]
}
